<template>
  <div class="otp-container">
    <input
      v-for="(_, index) in otpLength"
      :key="index"
      :value="otp[index]"
      maxlength="1"
      class="otp-box"
      type="text"
      inputmode="numeric"
      pattern="[0-9]*"
      @input="onInput($event, index)"
      @keydown="onKeyDown($event, index)"
      @paste="onPaste"
      ref="otpRefs"
      :autofocus="index === 0"
    />
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, onMounted, watch } from 'vue';

const otpLength = 6;
const otp = ref(Array(otpLength).fill(''));
const otpRefs = ref([]);

onMounted(() => {
  otpRefs.value = Array.from(document.querySelectorAll('.otp-box'));
});

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
});
const emit = defineEmits(['update:modelValue']);

watch(
  () => props.modelValue,
  (newVal) => {
    const filled = newVal.slice(0, otpLength).split('');
    otp.value = [...filled, ...Array(otpLength - filled.length).fill('')];
  },
  { immediate: true }
);

const onInput = (event, index) => {
  const value = event.data || event.target.value;
  if (!/^\d$/.test(value)) {
    event.target.value = ''; 
    return;
  }

  otp.value[index] = value;
  emit('update:modelValue', otp.value.join(''));

  // Move focus to next box
  if (index < otpLength - 1) {
    otpRefs.value[index + 1]?.focus();
  }
};

const onKeyDown = (event, index) => {
  if (event.key === 'Backspace') {
    if (otp.value[index] === '') {
      // Go back and clear previous box
      if (index > 0) {
        otp.value[index - 1] = '';
        emit('update:modelValue', otp.value.join(''));
        otpRefs.value[index - 1]?.focus();
      }
    } else {
      // Clear current box only
      otp.value[index] = '';
      emit('update:modelValue', otp.value.join(''));
      // Prevent default backspace behavior
      event.preventDefault();
    }
  }
};

const onPaste = (event) => {
  event.preventDefault();
  const pasted = event.clipboardData.getData('text').replace(/\D/g, '').slice(0, otpLength);
  for (let i = 0; i < otpLength; i++) {
    otp.value[i] = pasted[i] || '';
  }
  emit('update:modelValue', otp.value.join(''));

  const nextEmpty = otp.value.findIndex((val) => val === '');
  if (nextEmpty >= 0) {
    otpRefs.value[nextEmpty]?.focus();
  } else {
    otpRefs.value[otpLength - 1]?.blur();
  }
};
</script>

